import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/atendimentos',
    name: 'rota-atendimentos',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Atendimentos',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Atendimentos',
      icon: 'balance-scale',
    },
    component: () => import(/* webpackChunkName: "atendimentos" */ '../views/atendimentos/Atendimentos.vue'),
  },
]
